import { getJobApiCall, getJobApiTextCall } from "../../utils/jobRequest";
import { handle403Logout } from "../../utils/request";

export const fetchIdibuStatus = () => async () => {
  try {
    const res = await getJobApiCall("idibu/status");
    if (res?.status === 200) {
      return res.data?.data ?? res.data;
    }
    return { effective_enabled: false };
  } catch (error) {
    handle403Logout(error?.originalError || error);
    return { effective_enabled: false };
  }
};

export const fetchIdibuIframeHtml = (jobId) => async () => {
  try {
    const res = await getJobApiTextCall(`idibu/jobs/${jobId}/iframe-frame`);
    if (res?.status === 200 && typeof res.data === "string") {
      return { success: true, html: res.data };
    }
    return {
      success: false,
      message: res?.data?.detail || "Failed to open Idibu posting",
    };
  } catch (error) {
    handle403Logout(error?.originalError || error);
    return {
      success: false,
      message: error?.parsedMessage || error?.response?.data?.detail || "Failed to open Idibu posting",
    };
  }
};
